// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom";
import { Modal, Button, Form } from "react-bootstrap";
import "../css/Modal.css";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import _ from "lodash";
import axios from "axios";
import Geocode from "react-geocode";
import publicIp from "react-public-ip";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
// import {Spin} from 'antd'
import "react-datetime-picker/dist/DateTimePicker.css";
import { logo } from "../assets/icons";
import config from "../config.json";

// const customStyles = {
//   control: base => ({
//     ...base,
//     height: 45,
//     minHeight: 45,
//     backgroundColor: '#f2f2f2'
//   })
// };

const styles = {
  marginGap: {
    margin: 10,
    flex: 0.5,
    cursor: "pointer",
  },
  rowAlign: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

const weatherOptions = [
  { label: "No Cloud", value: "No Cloud" },
  { label: "Some Cloud", value: "Some Cloud" },
  { label: "Overcast", value: "Overcast" },
  { label: "High Winds", value: "High Winds" },
  { label: "Rain", value: "Rain" },
  { label: "Fog", value: "Fog" },
];

const activityDisturbedOptions = config.activityDisturbedOptions;

const natureOfComplaintOptions = config.natureOfComplaintOptions;
const aircraftTypeFormSelect = config.aircraftTypeFormSelect;

class NoiseComplaintModal extends React.Component<any> {
  constructor(props) {
    super(props);

    //let today = new Date();
    //let date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear() + ' @ ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

    this.state = this.initialState();
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.autocomplete = null;
    this.selectedOption = null;
    this.selectedValue = null;
    //isOtherUnknown: false
  }

  //componentDidMount() {
  //  this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'),
  //  {
  //  types: ['geocode']
  //})

  //google.maps.event.addListener(this.autocomplete, "place_changed", this.handlePlaceSelect)
  //}

  initialState() {
    return {
      eventDate: "",
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      code: "",
      complaintBox: "",
      aircraftType: "Select",
      aircraftEnable: false,
      aircraftOther: "",
      flightDirection: "Select",
      directionDisable: false,
      directionOther: "",
      weather: "",
      flightId: "",
      subDivision: "",
      comments: "",
      responseRequested: config.responseRequest.defaultSelected,
      emailValue: false,
      otherResponse: "",
      phoneValue: false,
      otherRequest: "",
      activityDisturb: "",
      timeDisturb: "",
      countyDistrict: "",
      latitude: "",
      longitude: "",
      NoiseChecked: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
        six: false,
        seven: false,
        eight: false,
      },
      noiseType: [],
      noiseString: "",
      terms: false,
      save: true,
      ipAddress: "",
      isSaving: false,
      isShowError: false,
      addressInput: "",
    };
  }

  getCurrentDateFormat = (val) => {
    let date = new Date(val);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let hour = date.getHours();
    let minutes = date.getMinutes();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (minutes < 10) minutes = "0" + minutes;
    let today =
      year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":00";
    return today;
  };

  componentDidMount() {
    this.setState({ eventDate: new Date() });
    this.getIpAddress();
  }

  // getIpAddress=()=> {
  //   const IPurl = "https://geolocation-db.com/jsonp/afa4d000-8eb9-11eb-a6ff-2538b793e762"
  //   const resp= axios.get(IPurl);
  //   resp.then((res) => {
  //     let json = res.data;
  //     let jsonSplit = json.split("callback(");
  //     let jsonSplit1 = jsonSplit[1].split(")");
  //     let ip = JSON.parse(jsonSplit1[0]);
  //     this.setState({ipAddress : ip.IPv4});
  //   })
  // }

  renderMultiSelectField = ({ options, name }) => {
    return (
      <Select
        name={name}
        isMulti={true}
        closeMenuOnSelect={false}
        menuPlacement="auto"
        options={options}
        onChange={this.handleSelectChange}
        autoFocus={true}
        styles={{
          control: (styles) => ({
            ...styles,
            border: "2px solid #ccc",
            backgroundColor: "#f2f2f2",
          }),
          multiValueLabel: (styles, { data }) => {
            return {
              ...styles,
              fontSize: "16px",
            };
          },
        }}
        value={this.state[name]}
      />
    );
  };

  getIpAddress = async () => {
    const ipv4 = (await publicIp.v4()) || "";
    this.setState({ ipAddress: ipv4 });
  };

  latLongitude = (lat, lng) => {
    this.setState({ latitude: lat });
    this.setState({ longitude: lng });
  };

  handlePlaceSelect = (e) => {
    const address = e.label;
    if (address.length > 0) {
      if (isNaN(Number(address[0]))) {
        this.props.onError("Please enter address with house number");
        this.setState({ address: "" });
        return;
      }
    }
    //var place = getLatLng(this.autocomplete);
    // set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
    Geocode.setApiKey(config.geoApiKey);

    // set response language. Defaults to english.
    Geocode.setLanguage("en");
    Geocode.fromAddress(e.label).then(
      (response) => {
        let cityArray = _.filter(
          response.results[0].address_components,
          (v) => v.types[0] == "locality"
        );
        let postal_code = _.filter(
          response.results[0].address_components,
          (v) => v.types[0] == "postal_code"
        );
        if (cityArray.length) {
          this.setState({ city: `${cityArray[0].long_name}` });
        }
        if (postal_code.length) {
          this.setState({ code: `${postal_code[0].long_name}` });
        }
      },
      (error) => {
        console.error(error);
      }
    );

    this.setState({ address: e.label });
    geocodeByAddress(e.label)
      .then((results) => {
        return getLatLng(results[0]);
      })
      .then(({ lat, lng }) => {
        this.latLongitude(lat, lng);
        // console.log('Successfully got latitude and longitude', { lat, lng })
      });
  };

  aircraftTypeHandle = (e) => {
    this.setState({ aircraftOther: e.target.value });
  };
  responseEmailHandle = (e) => {
    this.setState({ otherResponse: e.target.value });
  };
  responsePhoneHandle = (e) => {
    this.setState({ otherRequest: e.target.value });
  };

  directionHandle = (e) => {
    this.setState({ directionOther: e.target.value });
  };

  onChange = (event, type) => {
    if (type === "dateTime") {
      this.setState({ eventDate: event });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  onTermChange = () => {
    this.setState({ terms: !this.state.terms });
    this.setState({ save: !this.state.save });
  };

  // onCheckboxChange = (event) => {
  //   if (event.target.checked == true) {
  //     let noiseType = [...this.state.noiseType]
  //     noiseType.push(event.target.name);
  //     this.setState({ noiseType: noiseType });
  //     console.log('onCheckboxChange-noiseType-before-if', noiseType)
  //   }
  //   else {
  //     let noiseType = [...this.state.noiseType]
  //     noiseType.splice(noiseType.indexOf(event.target.name), 1);
  //     this.setState({ noiseType: noiseType });
  //     console.log('onCheckboxChange-noiseType-before-else', noiseType)
  //   }
  //   const NoiseChecked = { ...this.state.NoiseChecked, [event.target.id]: event.target.checked }
  //   console.log('onCheckboxChange-NoiseChecked', NoiseChecked)
  //   this.setState(() => ({ NoiseChecked }))
  //   //   this.setState(prevState => ({
  //   //     NoiseChecked: {
  //   //         ...prevState.NoiseChecked,
  //   //         [event.target.id]: event.target.checked
  //   //     }
  //   // }))
  //   // this.setState({NoiseChecked: { [event.target.id] : event.target.checked } });
  //   setTimeout(() => {
  //     let noiseString = this.state.noiseType.join(",");
  //   console.log('onCheckboxChange-noiseString-after', noiseString)

  //     this.setState({ noiseString: noiseString });
  //   }, 2000)
  // }

  enableDisableTextBox = (textVisible) => {
    this.setState({ aircraftType: textVisible.target.value });

    if (
      textVisible.target.value === "Unknown" ||
      textVisible.target.value === "Other"
    ) {
      this.setState({ aircraftEnable: true });
    } else {
      this.setState({ aircraftEnable: false });
    }
  };

  directionHandleBox = (flightRoot) => {
    this.setState({ flightDirection: flightRoot.target.value });

    if (
      flightRoot.target.value === "Unknown" ||
      flightRoot.target.value === "Other"
    ) {
      this.setState({ directionDisable: true });
    } else {
      this.setState({ directionDisable: false });
    }
  };

  responseRequestHandle = (responseRequest) => {
    this.setState({ responseRequested: responseRequest.target.value });
    this.setState({ responseRequested: responseRequest.target.value });

    if (responseRequest.target.value === "Yes Email") {
      this.setState({ emailValue: true });
    } else {
      this.setState({ emailValue: false });
    }

    if (responseRequest.target.value === "Yes Phone") {
      this.setState({ phoneValue: true });
    } else {
      this.setState({ phoneValue: false });
    }
  };

  // handleChange = (selectedOption) => {
  //   this.setState({ weather: selectedOption });
  //   console.log(`Option selected:`, selectedOption);
  // }

  handleSelectChange = (selectedValue, { name }) => {
    this.setState({ [name]: selectedValue });
  };

  // handleActivityChange = (selectedValue) => {
  //   this.setState({ activityDisturb: selectedValue });
  //   console.log(`value selected:`, selectedValue);
  // }

  showValidation = (name) => {
    return !this.state[name] && this.state.isShowError ? "field-required" : "";
  };

  submitFormButton = (ev) => {
    ev.preventDefault();
    const { eventDate, address, firstName, lastName } = this.state;
    if (
      eventDate &&
      address &&
      firstName &&
      lastName &&
      (this.state.phoneValue ? !!this.state.otherRequest : true) &&
      (this.state.emailValue ? !!this.state.otherResponse : true)
    ) {
      this.setState({ isShowError: false });
      let data = {
        DateTime: this.getCurrentDateFormat(this.state.eventDate),
        FirstName: this.state.firstName,
        LastName: this.state.lastName,
        Location: this.state.address,
        Latitude: this.state.latitude,
        Longitude: this.state.longitude,
        City: this.state.city,
        Zipcode: this.state.code,
        TypeProblem: (this.state.noiseString || [])
          .map((n) => n.value)
          .toString(),
        TypeAircraft: this.state.aircraftType,
        aircraftTypeOther: this.state.aircraftOther,
        Flightdirection: this.state.flightDirection,
        directionofFlightOther: this.state.directionOther,
        Weather: (this.state.weather || []).map((n) => n.value).toString(),
        FlightID: this.state.flightId,
        SubDivision: this.state.subDivision,
        AdditionalComments: this.state.comments,
        ResponseRequested: this.state.responseRequested,
        Email: this.state.otherResponse,
        Telephone: this.state.otherRequest,
        Activitydisturbed: (this.state.activityDisturb || [])
          .map((n) => n.value)
          .toString(),
        Timedisturbed: this.state.timeDisturb,
        IPAdrress: this.state.ipAddress,
      };

      //let values = JSON.stringfy(data)
      this.setState({ isSaving: true });
      // console.log("submit", data);
      const url = config.complaintURL;
      const body = data;
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "http://127.0.0.1:3000",
        "Access-Control-Allow-Credentials": "true",
      };
      const response = axios.post(url, body, headers);
      response
        .then((res) => {
          if (res.data?.status) {
            this.clearForm();
            setTimeout(() => {
              this.setState({ isSaving: false });
              this.props.onSubmitted();
            }, 250);
          } else {
            this.setState({ isSaving: false });
            this.props.onError("There is error on submission");
          }
        })
        .catch((err) => {
          this.props.onError("There is error on submission");
        });
    } else {
      this.setState({ isShowError: true });
    }
  };

  openTermsFile = () => {
    // window.open(require('../assets/files/terms_and_conditions.pdf'));
  };

  clearForm = () => {
    this.setState({
      eventDate: "",
      firstName: "",
      lastName: "",
      address: "",
      city: "",
      code: "",
      complaintBox: "",
      aircraftType: "Select",
      aircraftEnable: false,
      aircraftOther: "",
      flightDirection: "Select",
      directionDisable: false,
      directionOther: "",
      weather: "",
      flightId: "",
      subDivision: "",
      comments: "",
      responseRequested: "No",
      emailValue: false,
      otherResponse: "",
      phoneValue: false,
      otherRequest: "",
      activityDisturb: "",
      timeDisturb: "",
      latitude: "",
      longitude: "",
      NoiseChecked: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
        six: false,
        seven: false,
        eight: false,
      },
      noiseType: [],
      noiseString: "",
      terms: false,
      save: true,
      ipAddress: "",
      addressInput: "",
    });
  };

  onDatePickerRef = (picker) => {
    if (picker) {
      const pickerEl = ReactDOM.findDOMNode(picker);
      pickerEl.tabIndex = -1;
    }
  };

  render() {
    return (
      <Modal
        show={this.props.show}
        size="lg"
        dialogClassName="large-content"
        aria-labelledby="contained-modal-title-vcenter"
        // centered={'true'}
      >
        {/* <Spin spinning={this.state.isSaving}> */}
        <div
          style={{
            margin: "10px",
            border: "solid",
            borderWidth: "4px",
            borderColor: "grey",
          }}
        >
          <div style={{ height: "90px" }}>
            <div className="pic">
              <img
                src={logo}
                width="120px"
                height="85px"
                style={{
                  float: "left",
                  display: "flex",
                  flex: "1px",
                  marginTop: "0px",
                  marginBottom: "15px",
                  position: "absolute",
                  marginLeft: "10px"
                }}
              />
            </div>
            <div className="close">
              <button
                id="x"
                style={{
                  float: "right",
                  display: "flex",
                  flex: "1px",
                  marginTop: "25px",
                  right: "15px",
                  fontSize: 13,
                }}
                onClick={this.props.onHide}
              >
                X
              </button>
            </div>
            <Modal.Title
              id="contained-modal-title-vcenter"
              style={{
                display: "flex",
                paddingTop: "20px",
                justifyContent: "center",
              }}
            >
              {`${config.noiseHeading} `}
            </Modal.Title>
          </div>
          <div className="container">
            <form>
              <div className="topContainer">
                <div className="item">
                  <label className="required" style={{ marginLeft: 0 }}>
                    EVENT DATE:
                  </label>
                  <br></br>
                  {/* <input name={'eventDate'} id='date' 
                  className={`form-control input-lg ${this.showValidation('eventDate')}`}
                  value={this.state.eventDate} style={{ marginLeft: 0, backgroundColor: '#f2f2f2' }}  type='datetime-local' onChange={this.onChange} 
                   required /> */}

                  {/* onKeyUp={this.manage} */}
                  {/* <div className={`form-control input-lg ${this.showValidation('eventDate')}`} > */}
                  <DateTimePicker
                    onRef={this.onDatePickerRef}
                    className={this.showValidation("eventDate")}
                    amPmAriaLabel="Select AM/PM"
                    calendarAriaLabel="Toggle calendar"
                    clearAriaLabel="Clear value"
                    dayAriaLabel="Day"
                    hourAriaLabel="Hour"
                    maxDetail="minute"
                    minuteAriaLabel="Minute"
                    monthAriaLabel="Month"
                    nativeInputAriaLabel="Date and time"
                    onChange={(e) => this.onChange(e, "dateTime")}
                    secondAriaLabel="Second"
                    value={this.state.eventDate}
                    yearAriaLabel="Year"
                    showLeadingZeros={true}
                    clearIcon={null}
                  />
                  {/* </div> */}
                </div>

                <div className="item">
                  <label className="required">ADDRESS : </label>
                  <div className="subcontainer">
                    <GooglePlacesAutocomplete
                      apiKey={config.geoApiKey}
                      key={this.state.address}
                      ref={(ref) => {
                        this.autocomplete = ref;
                      }}
                      selectProps={{
                        value: this.state.address
                          ? {
                              value: this.state.address,
                              label: this.state.address,
                            }
                          : {
                            value: 'Type',
                            label: 'Type',
                          },
                        inputValue: this.state.addressInput,
                        onInputChange: (e) => {
                          this.setState({ addressInput: e });
                        },
                        onChange: this.handlePlaceSelect,
                        className: `google-places-${this.showValidation(
                          "address"
                        )}`,
                        placeholder: "Type",
                      }}
                      id="address"
                      name={"address"}
                      required
                    />
                  </div>
                </div>
                <div className="item">
                  <label className="required" style={{ marginLeft: 0 }}>
                    FIRST NAME :{" "}
                  </label>
                  <input
                    type="text"
                    id="fname"
                    name={"firstName"}
                    style={{
                      width: "100%",
                      marginLeft: 0,
                      backgroundColor: "#f2f2f2",
                    }}
                    value={this.state.firstName}
                    className={`form-control input-lg ${this.showValidation(
                      "firstName"
                    )}`}
                    placeholder="First Name"
                    onChange={this.onChange}
                    required
                  />
                  {/* onKeyUp={this.manage}  */}
                </div>

                <div className="item">
                  <label className="required">LAST NAME : </label>
                  <input
                    type="text"
                    id="lname"
                    name={"lastName"}
                    style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                    value={this.state.lastName}
                    className={`form-control input-lg ${this.showValidation(
                      "lastName"
                    )}`}
                    placeholder="Last Name"
                    onChange={this.onChange}
                    required
                  />
                  {/* onKeyUp={this.manage} */}
                </div>
                <div className="item">
                  <label style={{ marginLeft: 0 }}>
                    NATURE OF CONCERN (MULTI-SELECT) :{" "}
                  </label>
                  <div className="" style={{ marginLeft: 0, width: "100%" }}>
                    {this.renderMultiSelectField({
                      options: natureOfComplaintOptions,
                      name: "noiseString",
                    })}
                  </div>
                </div>
                <div className="item" style={{ float: "right" }}>
                  <div className="flight">
                    <label>FLIGHT ID : </label>
                    <input
                      type="text"
                      id="flightid"
                      style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                      className="form-control input-lg"
                      name={"flightId"}
                      value={this.state.flightId}
                      onChange={this.onChange}
                      required
                    />
                  </div>
                </div>
                {activityDisturbedOptions.length > 0 ? (
                  <div className="item">
                    <label htmlFor="activity" style={{ marginLeft: 0 }}>
                      ACTIVITY DISTURBED (MULTI-SELECT) :{" "}
                    </label>
                    <div className="activitybox" style={{ marginLeft: 0 }}>
                      {this.renderMultiSelectField({
                        options: activityDisturbedOptions,
                        name: "activityDisturb",
                      })}
                      {/* <Select isMulti={true}
                      closeMenuOnSelect={false}
                        menuPlacement='auto'
                        options={option}
                        onChange={this.handleSelectChange}
                        autoFocus={true}
                        value={this.state.activityDisturb}
                        name={'activityDisturb'}
                        // styles={customStyles} 
                        /> */}
                    </div>
                  </div>
                ) : null}

                <div className="item">
                  <label>TIME DISTURBED : </label>
                  <select
                    className="form-control input-lg"
                    style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                    name={"timeDisturb"}
                    id="time"
                    value={this.state.timeDisturb}
                    onChange={this.onChange}
                    required
                  >
                    <option value="Select">Select</option>
                    <option value="1 - 5 minutes">1 - 5 minutes</option>
                    <option value="6 - 10 minutes">6 - 10 minutes</option>
                    <option value="11 - 30 minutes">11 - 30 minutes</option>
                    <option value="30 minutes +">30 minutes +</option>
                  </select>
                </div>
                <div
                  className="item"
                  style={{ float: "left", display: "table" }}
                >
                  <label style={{ marginLeft: 0 }}>AIRCRAFT TYPE : </label>
                  <select
                    className="form-control input-lg"
                    id="textVisible"
                    style={{
                      width: "100%",
                      marginLeft: 0,
                      backgroundColor: "#f2f2f2",
                    }}
                    value={this.state.aircraftType}
                    onChange={this.enableDisableTextBox}
                    required
                  >
                    {aircraftTypeFormSelect.map((top) => (
                      <optgroup
                        key={top.optionHeading}
                        label={top.optionHeading}
                      >
                        {top.options.map((sub) => (
                          <option key={sub} value={sub}>
                            {sub}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </div>

                {this.state.aircraftEnable ? (
                  <div className="item" style={{ float: "right" }}>
                    <label>OTHER/UNKNOWN : </label>
                    <input
                      type="text"
                      className="form-control input-lg"
                      style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                      value={this.state.aircraftOther}
                      id="textOther"
                      onChange={this.aircraftTypeHandle}
                      required
                    />
                  </div>
                ) : null}
                <div className="item">
                  <label style={{ marginLeft: 0 }}>
                    DIRECTION OF FLIGHT :{" "}
                  </label>
                  <select
                    className="form-control input-lg"
                    id="flightRoot"
                    style={{ marginLeft: 0, backgroundColor: "#f2f2f2" }}
                    value={this.state.flightDirection}
                    onChange={this.directionHandleBox}
                    required
                  >
                    <option value="Select">Select</option>
                    <option value="North">North</option>
                    <option value="South">South</option>
                    <option value="West">West</option>
                    <option value="East">East</option>
                    <option value="Arrival">Arrival</option>
                    <option value="Departure">Departure</option>
                    <option value="Hovering">Hovering</option>
                    <option value="Circling">Circling</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="item">
                  <label>WEATHER (MULTI-SELECT) : </label>
                  <div className="" style={{ marginLeft: 0, width: "100%" }}>
                    {this.renderMultiSelectField({
                      options: weatherOptions,
                      name: "weather",
                    })}
                  </div>
                </div>

                {this.state.directionDisable ? (
                  <div className="item" style={{ marginLeft: 0 }}>
                    <div>
                      <label>OTHER/UNKNOWN : </label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                        value={this.state.directionOther}
                        id="option"
                        onChange={this.directionHandle}
                        required
                      />
                    </div>
                  </div>
                ) : null}
                {/* <div className="item">
                  <label style={{ marginLeft: 0 }}>SUBDIVISION : </label>
                  <textarea
                    rows="2"
                    style={{ marginLeft: 0, backgroundColor: "#f2f2f2" }}
                    className="form-control"
                    id="comments"
                    name={"subDivision"}
                    value={this.state.subDivision}
                    onChange={this.onChange}
                    required
                  />
                </div> */}

                <div className="item">
                  <label>COUNTY DISTRICT : </label>
                  <select
                    className="form-control input-lg"
                    style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                    name={"countyDistrict"}
                    id="countyDistrict"
                    value={this.state.countyDistrict}
                    onChange={this.onChange}
                    required
                  >
                    {config.countyDistrictSelect.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="item">
                  <label>ADDITIONAL COMMENTS : </label>
                  <textarea
                    rows="2"
                    maxLength="50"
                    style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                    className="form-control"
                    id="addcomment"
                    name={"comments"}
                    value={this.state.comments}
                    onChange={this.onChange}
                    required
                  />
                </div>
                <div className="item">
                  <label>RESPONSE REQUESTED : </label>
                  <select
                    className="form-control input-lg"
                    style={{ backgroundColor: "#f2f2f2" }}
                    id="responseRequest"
                    value={this.state.responseRequested}
                    onChange={this.responseRequestHandle}
                    required
                  >
                    {config.responseRequest.options.map((item) => (
                      <option value={item.value}>{item.label}</option>
                    ))}
                  </select>
                </div>

                {this.state.emailValue ? (
                  <div className="item">
                    <label className="required">EMAIL ADDRESS : </label>
                    <input
                      type="email"
                      id="email"
                      style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                      className={`form-control input-lg ${this.showValidation(
                        "otherResponse"
                      )}`}
                      value={this.state.otherResponse}
                      placeholder="example@domain.com"
                      onChange={this.responseEmailHandle}
                      required
                    />
                  </div>
                ) : null}

                {this.state.phoneValue ? (
                  <div className="item">
                    <label className="required">PHONE NUMBER : </label>
                    <input
                      type="number"
                      className={`form-control input-lg ${this.showValidation(
                        "otherRequest"
                      )}`}
                      style={{ width: "100%", backgroundColor: "#f2f2f2" }}
                      pattern="^\+?\d{0,13}"
                      id="number"
                      value={this.state.otherRequest}
                      placeholder="XXX-XXX-XXXX"
                      onChange={this.responsePhoneHandle}
                      required
                    />
                  </div>
                ) : null}
              </div>

              <div
                className="form-group row"
                style={{ marginTop: "15px", paddingLeft: "6px" }}
              >
                <div className="col-xs-8">
                  <input
                    type="checkbox"
                    style={{ marginLeft: 0 }}
                    className="value"
                    id="click-box"
                    checked={this.state.terms}
                    onChange={this.onTermChange}
                  ></input>
                  <a
                    style={styles.marginGap}
                    // onClick={this.openTermsFile}
                    href={config.termsAndConditionPath}  target="_blank" 
                    id="click-box"
                  >
                    {" "}
                    I accept the terms and conditions{" "}
                  </a>
                </div>

                <div className="col-xs-4">
                  <Button
                    type="button"
                    className="btn btn-info btn-lg"
                    style={{
                      fontWeight: "bold",
                      float: "right",
                    }}
                    id="btSave"
                    disabled={this.state.save}
                    onClick={this.submitFormButton}
                  >
                    SUBMIT
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* </Spin> */}
      </Modal>
    );
  }
}

export default NoiseComplaintModal;

// "aircraftTypeFormSelect": [
//   {
//       "optionHeading": "Airline",
//       "options":[
//           "Select",
//           "Air Canada",
//           "Allegiant",
//           "Delta",
//           "Swoop",
//           "Sun Country",
//           "United",
//           "Unknown"
//       ]

//   },
//   {
//       "optionHeading": "Military",
//       "options":[
//           "Coast Guard – Orange/ White Helicopter",
//           "Coast Guard – Orange/ White Airplane",
//           "Air Force – Grey Airplane",
//           "Army – Green Helicopter",
//           "Navy/ Marines – Grey Fighter Jet",
//           "Commercial Jet – White No Markings"
//       ]
//   },
//   {
//       "optionHeading": "General Aviation",
//       "options":[
//           "Corporate Jet",
//           "Small helicopter",
//           "Small prop airplane",
//           "Aircraft in a general sense",
//           "Other"
//       ]
//   }
// ]

// const activityDisturbedOptions = [
//   { label: "Sleep", value: "Sleep" },
//   { label: "Work", value: "Work" },
//   { label: "Watching TV/ Movie", value: "Watching TV/ Movie" },
//   { label: "Phone conversation", value: "Phone conversation" },
//   { label: "Mealtime", value: "Mealtime" },
//   { label: "Peace & Quiet", value: "Peace & Quiet" },
//   { label: "Animals", value: "Animals" },
//   { label: "Other", value: "Other" },
// ];
